import { useState, useCallback, useEffect, useLayoutEffect } from 'react'
import * as _ from 'lodash-es'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

type StorageOptions = {
  reviver?: (this: any, key: string, value: any) => any
  replacer?: (this: any, key: string, value: any) => any
}

export const useStorage = (storage: Storage, locStorKey: string | string[], initialVal?: any, options?: StorageOptions) => {
  if (_.isArray(locStorKey)) locStorKey = locStorKey.join('-')

  const [storedValue, setStoredValue] = useState(initialVal)

  useIsomorphicLayoutEffect(() => {
    try {
      const encoded = storage.getItem(locStorKey as string)
      if (encoded === null || encoded === 'undefined') return
      const state = JSON.parse(encoded, options?.reviver)
      if (_.has(state, '_fixSerializeOfFalsies')) {
        setStoredValue(state._fixSerializeOfFalsies)
      } else {
        setStoredValue(state)
      }
    } catch (ee) {
      storage.removeItem(locStorKey as string)
    }
  }, [locStorKey])

  const setValue = useCallback((valueOrFn: any) => {
    setStoredValue((prevValue: any) => {
      const newValue = _.isFunction(valueOrFn) ? valueOrFn(prevValue) : valueOrFn
      
      let valueForStorage = newValue
      if (valueForStorage == undefined) {
        valueForStorage = null
      }

      const serNewVal = valueForStorage ? JSON.stringify(valueForStorage, options?.replacer) : JSON.stringify({_fixSerializeOfFalsies: valueForStorage}, options?.replacer)
      storage.setItem(locStorKey as string, serNewVal)
      
      return newValue
    })
  }, [locStorKey, options, storage])

  return [storedValue, setValue]
}
